import { Form as AntdForm, Radio } from 'antd'
import { DateStyles } from 'components/DatePickerStyles/DatePickerStyles'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import RadioButton from 'components/Form/RadioButton'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
`
export const Form = styled(AntdForm)`
  row-gap: 20px;
  display: flex;
  flex-direction: column;
`
export const TwoFields = styled(Flex)`
  align-items: ${props => props.align};
  gap: 20px;
`
export const TwoFieldsLabel = styled(Flex)`
  gap: 230px;
`

export const StyledDate = styled(DateStyles)`
  margin-top: 5px;
`
export const RadioGroup = styled(Radio.Group)`
  display: flex;
`
export const StyledRadio = styled(RadioButton)`
  margin-top: 10px;
`
export const SectionHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 10px 0;
  color: ${COLORS.GREY_T_20};
`
export const StyledInputDiv = styled(Flex)`
  margin-bottom: 20px !important;
  align-items: flex-end;
  position: sticky;
  align-items: baseline;
  width: 100%;
  border-radius: 8px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: 0;
  }
`

export const SelectInputDiv = styled(Flex)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '20px'} !important;
  margin-top: ${props =>
    props.margintop ? props.margintop : '0px'} !important;
  align-items: flex-end;
  position: sticky;
  align-items: stretch;
  width: ${props => (props.width ? props.width : '100%')};
  border-radius: 8px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: ${props =>
      props?.borderright ? '8px' : 0} !important;
    border-bottom-right-radius: ${props =>
      props?.borderright ? '8px' : 0} !important;
    border-right: ${props =>
      props?.borderright
        ? `${props?.borderright} solid  #e9e9e9`
        : 0} !important;

    border-top-left-radius: ${props =>
      props?.borderleft ? '8px' : 0} !important;
    border-bottom-left-radius: ${props =>
      props?.borderleft ? '8px' : 0} !important;
  }
`

export const FooterFlex = styled(Flex)`
  gap: 20px;
`
export const StyledInput = styled(Input)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
`
export const MarksFlex = styled(Flex)`
  gap: 20px;
  width: 40%;
`
export const SpinWrapper = styled(Flex)`
  padding-top: 30px;
  padding-bottom: 30px;
`
